import React, { type FC } from 'react'

interface IconPlusProps {
  width?: string
  height?: string
}

const IconPlus: FC<IconPlusProps> = ({ width = '14', height = '16' }) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"
        fill="currentColor"
        shapeRendering="geometricPrecision"
      />
    </svg>
  )
}

export default IconPlus

/**
 *
 * <svg
      width={width}
      height={height}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 448 512'
    >
      <path
        d='M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z'
        fill='currentColor'
        shapeRendering='geometricPrecision'
      />
    </svg>
 */

/**
 * 
 * 
 <svg
      width={width}
      height={height}
      viewBox='0 0 15 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.36538 1.36538C8.36538 0.885817 7.97957 0.5 7.5 0.5C7.02043 0.5 6.63462 0.885817 6.63462 1.36538V7.13462H0.865385C0.385817 7.13462 0 7.52043 0 8C0 8.47957 0.385817 8.86538 0.865385 8.86538H6.63462V14.6346C6.63462 15.1142 7.02043 15.5 7.5 15.5C7.97957 15.5 8.36538 15.1142 8.36538 14.6346V8.86538H14.1346C14.6142 8.86538 15 8.47957 15 8C15 7.52043 14.6142 7.13462 14.1346 7.13462H8.36538V1.36538Z'
        fill='currentColor'
        shapeRendering='geometricPrecision'
      />
    </svg>
 */
